<template>
   <v-row class="d-flex justify-center" no-gutters>
        <v-col cols="12" xs="12" sm="12" md="12" lg="8" xl="8" class="">
            <v-row class="pt-4 px-5 justify-center">
                <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5" class="d-flex justify-center">
                     <!-- class="d-flex justify-center" style="border-top-radius: 100px !important;"-->
                     <div style="width: 300px !important; border: 0px solid black;">
                         <v-img contain :src="require('@/assets/tfw_logo_light.png')" />
                    </div>
                </v-col>
            </v-row>
            <v-row class="d-flex justify-center mt-1">
                <v-col cols="11" xs="11" sm="5" class="pa-5">
                    <firebase-auth-register />
                </v-col>
            </v-row>
            <!-- <v-row class="d-flex justify-center text-center mt-1">
                <v-col cols="12" xs="12" sm="6">
                    <p>Don't have an account? <router-link :to="{ path: 'register' }" replace class="btn btn-link">Register</router-link> 
                    <br/>
                    <span>Forgot Password <router-link :to="{ path: 'reset-password' }" replace class="btn btn-link" >Reset password</router-link></span></p>                    
                </v-col>
            </v-row> -->
        </v-col>
    </v-row>
</template>

<script>
export default {
  name: "Register",
};
</script>


